var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-data__input"},[_c('Select',{attrs:{"value":_vm.periodText,"selectData":_vm.periodsList},on:{"params":_vm.choosenPeriod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }